/**
 * 멤버십 상품 구성 설정
 * - 가격, 문구, 링크 변경 시 이 파일만 수정하면 됩니다.
 *
 * [구조]
 * BASE_PRODUCTS(상품 뼈대) ← CAMPAIGNS[campaignId].products(캠페인 공통 혜택)
 * ← PROMOTIONS[].products(개별 프로모션 오버라이드) 순서로 얕은 머지됩니다.
 * price / subDesc / badge 같은 객체 필드는 통째로 교체되므로
 * 오버라이드하는 쪽이 그 필드의 완성값을 선언하세요.
 *
 * [새 프로모션 추가]
 * 1. 혜택이 기존 캠페인과 같으면 → PROMOTIONS에 기간·배너만 추가 (campaignId 지정)
 * 2. 혜택 구성이 다르면 → CAMPAIGNS에 새 캠페인(layout + products)을 만들고 연결
 * 3. 특정 주차만 문구/가격이 다르면 → 해당 PROMOTIONS 항목의 products에 그 필드만 오버라이드
 *
 * [필드 형식]
 * - price: { original: '취소선 원가(생략 시 미노출)', discount: '판매가' }
 * - subDesc: '문자열' 또는 { text: '...', colored: true }  (colored: 강조색 적용)
 * - badge: { image: 'discount100' | 'discount200' } 또는 { text: 'HTML 텍스트' }  (생략 시 미노출)
 * - 배너 선물 이미지: 이미지를 import 후 GIFT_IMAGES에 등록하고 banner.giftImage에 키 지정
 */

import IMG_GIFT_4 from '@/assets/membership/img/img-gift4.png'
import IMG_GIFT_DK1000 from '@/assets/membership/img/img-gift-dk1000.png'
import IMG_GIFT_SLIMY from '@/assets/membership/img/img-gift-slimy.png'

/** PROMOTIONS.banner.giftImage 키 → 실제 이미지 */
const GIFT_IMAGES = {
    gift4: IMG_GIFT_4,
    giftDk1000: IMG_GIFT_DK1000,
    giftSlimy: IMG_GIFT_SLIMY
}

/** badge.image 키 → CSS 클래스 (badge-100 = ¥100 할인 배지, badge-200 = ¥200 할인 배지) */
const BADGE_CLASSES = {
    discount100: 'badge-100',
    discount200: 'badge-200'
}

const SUBTITLE = '(2个孩子使用)'

/** 상품 뼈대 — 프로모션과 무관한 공통값 (프로모션 화면에서 layout의 상품 ID로 참조) */
const BASE_PRODUCTS = {
    year2: { title: '2年卡', subtitle: SUBTITLE },
    year1: { title: '1年卡', subtitle: SUBTITLE },
    half: { title: '半年卡', subtitle: SUBTITLE },
    day7: {
        title: '7日卡',
        subtitle: SUBTITLE,
        price: { original: '32', discount: '9.9' },
        bonusDescHidden: true,
        subDesc: '仅限新用户购买',
        badge: { text: '新用户<br>专享' },
        headerLeftAlign: true,
        link: 'https://shop91489875.m.youzan.com/wscgoods/detail/2omys8klrnxyjui?scan=1&activity=none&from=kdt&qr=directgoods_4095495506&shopAutoEnter=1'
    }
}

const GIFT_SUB_DESC_1111 = { text: '送Orchard Toys游戏礼盒1盒', colored: true }

/** 캠페인 = 여러 프로모션이 공유하는 레이아웃 + 상품 혜택 */
const CAMPAIGNS = {
    '2026-09': {
        layout: [['year2', 'year1'], ['half', 'day7']],
        products: {
            year2: {
                price: { discount: '888', original: '988' },
                bonusDesc: '加赠9个月',
                subDesc: '（每个孩子0.45/天）',
                link: 'https://sourl.co/m4fpd9',
                badge: { image: 'discount100' }
            },
            year1: {
                price: { discount: '599', original: '699' },
                bonusDesc: '加赠6个月',
                subDesc: '（每个孩子0.56/天）',
                link: 'https://sourl.co/LDXP6m',
                badge: { image: 'discount100' }
            },
            half: {
                price: { discount: '480', original: '580' },
                bonusDesc: '加赠5个月',
                subDesc: '（每个孩子0.75/天）',
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/3nfq9e1q7aoq3?scan=1&activity=none&from=kdt&qr=directgoods_888245981&shopAutoEnter=1',
                badge: { image: 'discount100' }
            }
            // day7 은 BASE_PRODUCTS 그대로 사용 → 오버라이드 없음
        }
    }
}

/** 개별 프로모션 = 기간 + 배너 + (필요시) 캠페인 위 추가 오버라이드 */
export const PROMOTIONS = [
    {
        id: '260917',
        campaignId: '2026-09',
        start: '2026-09-17 01:00:00',
        end: '2026-10-11 01:00:00',
        banner: {
            title: '都都周年庆 最大优惠',
            periodDesc: '（9月17日-10月10日）',
            giftImage: null
        },
    },
    {
        id: '261026',
        start: '2026-10-26 01:00:00',
        end: '2026-11-12 01:00:00',
        banner: {
            title: '双十一优惠大促',
            periodDesc: '（仅10月26日-11月11日期间）',
            giftImage: 'giftSlimy'
        },
        // 단독 프로모션 — 캠페인 없이 자체 layout/products 사용
        layout: [['year2', 'year1'], ['half', 'day7']],
        products: {
            year2: {
                price: { discount: '988' },
                bonusDesc: '加赠9个月',
                subDesc: GIFT_SUB_DESC_1111,
                link: 'https://sourl.co/m4fpd9'
            },
            year1: {
                price: { discount: '699' },
                bonusDesc: '加赠6个月',
                subDesc: GIFT_SUB_DESC_1111,
                link: 'https://sourl.co/LDXP6m'
            },
            half: {
                price: { discount: '480' },
                bonusDesc: '加赠6个月',
                subDesc: GIFT_SUB_DESC_1111,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/3nfq9e1q7aoq3?scan=1&activity=none&from=kdt&qr=directgoods_888245981&shopAutoEnter=1'
            }
            // day7 은 BASE_PRODUCTS 그대로 사용
        }
    }
]

/** 뷰 타입별 상품 구성 — 프로모션과 무관한 정적 데이터 */
export const VIEW_PRODUCTS = {
    membership: {
        title: '续费专用',
        desc: ['减轻压力 续航学习时间!'],
        products: [
            {
                title: '2年卡',
                subtitle: SUBTITLE,
                price: { original: '988', discount: '688' },
                priceDesc: '（每个孩子 0.4/天）',
                subDesc: '下单后请联络官方开通',
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/3f1xxe0cueajfjp?scan=1&activity=none&from=kdt&qr=directgoods_3801584580&shopAutoEnter=1'
            },
            {
                title: '1年卡',
                subtitle: SUBTITLE,
                price: { original: '699', discount: '399' },
                priceDesc: '（每个孩子 0.55/天）',
                subDesc: '下单后请联络官方开通',
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/2x5pjcgc3ahhnw2?scan=1&activity=none&from=kdt&qr=directgoods_2878500740&shopAutoEnter=1'
            },
            {
                title: '半年卡',
                subtitle: SUBTITLE,
                price: { original: '580', discount: '309' },
                priceDesc: '（每个孩子 0.88天）',
                subDesc: '下单后请联络官方开通',
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/3evqn19n4b18b0a?scan=1&activity=none&from=kdt&qr=directgoods_5518885667&shopAutoEnter=1'
            }
        ]
    },
    new: {
        title: '新注册专项',
        desc: ['注册7日内下单, ', '立减 ¥100!'],
        products: [
            {
                title: '2年卡',
                subtitle: SUBTITLE,
                price: { original: '988', discount: '888' },
                bonusDesc: '24个月 +赠9个月',
                subDesc: '（每个孩子 0.45/天）',
                badge: { image: 'discount100' },
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/35y9nwlad0dq38j?scan=1&activity=none&from=kdt&qr=directgoods_3801576448&shopAutoEnter=1'
            },
            {
                title: '1年卡',
                subtitle: SUBTITLE,
                price: { original: '699', discount: '599' },
                bonusDesc: '12个月 +赠6个月',
                subDesc: '（每个孩子 0.55/天）',
                badge: { image: 'discount100' },
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/3npjt5comlz2zh4?scan=1&activity=none&from=kdt&qr=directgoods_3801584756&shopAutoEnter=1'
            },
            {
                title: '半年卡',
                subtitle: SUBTITLE,
                price: { original: '580', discount: '480' },
                bonusDesc: '6个月 +赠5个月',
                subDesc: '（每个孩子 0.72/天）',
                badge: { image: 'discount100' },
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/27cx3zxwqjr5727?scan=1&activity=none&from=kdt&qr=directgoods_2878500615&shopAutoEnter=1'
            }
        ]
    },
    all: {
        productsClass: 'no-title',
        products: [
            {
                title: '2年卡',
                subtitle: SUBTITLE,
                price: { discount: '988' },
                bonusDesc: '加赠9个月',
                subDesc: '（每个孩子0.49/天）',
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/1yj55vk0h4pfv?scan=1&activity=none&from=kdt&qr=directgoods_875457606&shopAutoEnter=1'
            },
            {
                title: '1年卡',
                subtitle: SUBTITLE,
                price: { discount: '699' },
                bonusDesc: '加赠6个月',
                subDesc: '（每个孩子0.64/天）',
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/1ye8ngkc8qm2j?scan=1&activity=none&from=kdt&qr=directgoods_888303865&shopAutoEnter=1'
            },
            {
                title: '半年卡',
                subtitle: SUBTITLE,
                price: { discount: '580' },
                bonusDesc: '加赠5个月',
                subDesc: '（每个孩子0.87/天）',
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/3nfq9e1q7aoq3?scan=1&activity=none&from=kdt&qr=directgoods_888245981&shopAutoEnter=1'
            },
            {
                title: '7日卡',
                subtitle: SUBTITLE,
                price: { original: '32', discount: '9.9' },
                bonusDescHidden: true,
                subDesc: '仅限新用户购买',
                badge: { text: '新用户<br>专享' },
                headerLeftAlign: true,
                link: 'https://shop91489875.m.youzan.com/wscgoods/detail/2omys8klrnxyjui?scan=1&activity=none&from=kdt&qr=directgoods_4095495506&shopAutoEnter=1'
            }
        ]
    }
}

function warnDev(message) {
    if (process.env.NODE_ENV !== 'production') {
        console.warn(`[membershipProducts] ${message}`)
    }
}

function normalizeBadge(badge) {
    if (!badge) return null
    if (badge.text) return { text: badge.text }
    if (badge.image) {
        const className = BADGE_CLASSES[badge.image]
        if (!className) {
            warnDev(`알 수 없는 badge image 키: ${badge.image}`)
            return null
        }
        return { className }
    }
    return null
}

function normalizeSubDesc(subDesc) {
    if (typeof subDesc === 'string') return { text: subDesc, colored: false }
    return {
        text: subDesc?.text ?? '',
        colored: subDesc?.colored ?? false
    }
}

/**
 * 상품 설정을 렌더링용 객체로 정규화
 * 카드 컴포넌트는 이 반환 형태만 신뢰한다 (설계 문서의 반환 계약 참고)
 */
export function normalizeProduct(product) {
    const badge = normalizeBadge(product.badge)

    return {
        title: product.title ?? '',
        subtitle: product.subtitle ?? '',
        price: {
            original: product.price?.original ?? null,
            discount: product.price?.discount ?? ''
        },
        bonusDesc: product.bonusDesc ?? '',
        bonusDescHidden: product.bonusDescHidden ?? false,
        priceDesc: product.priceDesc ?? '',
        subDesc: normalizeSubDesc(product.subDesc),
        badge,
        headerLeftAlign: product.headerLeftAlign ?? !!badge,
        link: product.link ?? ''
    }
}

/** 프로모션 화면 상품 — BASE ← 캠페인 ← 프로모션 순 얕은 머지 후 layout대로 배열 */
export function getPromotionProductRows(promotion) {
    if (!promotion) return []

    const campaign = CAMPAIGNS[promotion.campaignId]
    if (promotion.campaignId && !campaign) {
        warnDev(`알 수 없는 campaignId: ${promotion.campaignId}`)
    }

    const layout = promotion.layout || campaign?.layout || []

    return layout.map((row) => row.map((productId) => {
        if (!BASE_PRODUCTS[productId]) {
            warnDev(`알 수 없는 상품 ID: ${productId}`)
        }

        return normalizeProduct({
            ...BASE_PRODUCTS[productId],
            ...campaign?.products?.[productId],
            ...promotion.products?.[productId]
        })
    }))
}

/** 뷰 타입(membership/new/all)의 정적 상품 목록 */
export function getViewProducts(type) {
    const products = VIEW_PRODUCTS[type]?.products || []

    return products.map(normalizeProduct)
}

export function getActivePromotion(promotionId) {
    return PROMOTIONS.find((p) => p.id === promotionId) || null
}

/** 활성 프로모션의 배너 선물 이미지 — banner.giftImage 미지정 시 null */
export function getPromotionGiftImage(promotionId) {
    const promotion = getActivePromotion(promotionId)

    return GIFT_IMAGES[promotion?.banner?.giftImage] || null
}

/** 서버 시각 기준 현재 활성 프로모션 ID 탐색 */
export function findActivePromotionId(servertime, moment, options = {}) {
    if (!servertime) return 'membership'

    const { isProduction = true, testQuery = null } = options
    const now = moment(servertime)
    let promotionId = 'membership'

    for (const p of PROMOTIONS) {
        const checkStart = now.isAfter(moment(p.start))
        const checkEnd = now.isBefore(moment(p.end))

        if (
            isProduction && checkStart && checkEnd
            || !isProduction && checkEnd
        ) {
            promotionId = p.id
            break
        }
    }

    if (!isProduction && testQuery) {
        if (testQuery === 'normal') {
            return 'membership'
        }
        if (PROMOTIONS.find((p) => p.id === testQuery)) {
            return testQuery
        }
    }

    return promotionId
}
